import { apiClient } from "@/lib/api";
import type { Region } from "@/types";

export const regionKeys = {
  all: ["regions"] as const,
  active: () => [...regionKeys.all, "active"] as const,
};

export const regionService = {
  listActive: async (): Promise<Region[]> => {
    const response = await apiClient.get<Region[]>("/regions", {
      params: { active_only: true },
    });
    return response.data;
  },
};
